<template>
  <router-link :to="projectDetailsRoute(project)">
    <div
      class="avatar relative"
      :style="thumbnail && `background-image: url(${thumbnail.url})`"
      :class="[
        {'bg-cover' : thumbnail},
        {'avatar--small' : small},
        {'pa-2' : !thumbnail && small},
        {'pa-5' : !thumbnail && !small},
      ]"
    >
      <v-img
        v-if="!thumbnail || !thumbnail.url"
        class="d-block"
        src="@/assets/img/img-blank.svg"
      />
      <v-icon
        v-if="project.pinned"
        :x-small="small"
        :small="!small"
        class="pin-icon"
        :class="{'pin-icon--small' : small}"
        color="primary"
      >
        mdi-pin
      </v-icon>
    </div>
  </router-link>
</template>

<script>
import projectFormattedInfo from '@/mixins/projectFormattedInfo.vue';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    projectFormattedInfo, // projectDetailsRoute
  ],
  computed: {
    thumbnail() {
      const { youtubeThumbnailUrl, thumbnail } = this.project
      return  youtubeThumbnailUrl ? {url: youtubeThumbnailUrl} : thumbnail
    }
  }
};
</script>

<style lang="scss" scoped>
.pin-icon {
  position: absolute;
  height: 24px;
  width: 24px;
  padding: 4px;
  border-radius: 50%;
  background-color: $secondary;
  bottom: 0;
  right: 0;
  transform: translate(50%, 50%) rotate(45deg);
  border: 1px solid white;

  &--small {
    height: 20px;
    width: 20px;
  }
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: $secondary;
  border-radius: 0 !important;
  cursor:pointer;

  &--small {
    width: 32px;
    height: 32px;
  }
}
</style>
